import { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

const BLOCKS = [
  {
    h: "Unser Anspruch",
    t: "Die Dickies-Campus GmbH möchte, dass alle Menschen unsere Website und unsere Angebote gut nutzen können – unabhängig von Einschränkungen. Als Kleinstunternehmen unterliegen wir nicht den Pflichten des Barrierefreiheitsstärkungsgesetzes (BFSG); diese Erklärung und die umgesetzten Maßnahmen erfolgen freiwillig.",
  },
  {
    h: "Was wir umgesetzt haben",
    t: "Deutsche Sprachauszeichnung für Vorlesesoftware, semantische Seitenstruktur mit Überschriften, Alternativtexte bei zentralen Bildern, beschriftete Bedienelemente (ARIA), einen Skip-Link zum Inhalt, sichtbare Tastatur-Fokusmarkierungen sowie eine responsive Darstellung bis zu kleinen Bildschirmgrößen. Unsere Kurse selbst finden live und online statt – individuelle Bedürfnisse besprechen wir gern vorab in der kostenlosen Beratung.",
  },
  {
    h: "Geprüfter Stand",
    t: "Die Hauptseiten (Startseite, Kursseiten, Kursübersicht, Shop) wurden im Oktober 2026 mit dem Prüfwerkzeug axe-core automatisiert nach WCAG 2.1 AA geprüft – ohne verbleibende Verstöße. Zusätzlich bieten Kursseiten eine Vorlesefunktion. Einzelne ältere PDF-Dokumente (z. B. Leseproben) sind noch nicht vollständig barrierefrei aufbereitet; ein manueller Screenreader-Durchlauf aller Unterseiten steht noch aus.",
  },
  {
    h: "Barriere melden",
    t: "Du bist auf ein Hindernis gestoßen? Schreib uns an info@dickies-helden.de oder ruf an unter 0211 29273330 – wir kümmern uns zeitnah und finden gemeinsam einen zugänglichen Weg zu unseren Inhalten.",
  },
];

export default function Barrierefreiheit() {
  useEffect(() => {
    document.title = "Erklärung zur Barrierefreiheit · Dickies-Campus";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream-100">
      <Header />
      <main id="inhalt" className="max-w-3xl mx-auto px-5 pt-28 pb-20">
        <p className="text-xs font-semibold uppercase tracking-widest text-terra">Rechtliches</p>
        <h1 className="mt-2 font-heading font-bold text-4xl text-sand-800 tracking-tight">Erklärung zur Barrierefreiheit</h1>
        <p className="mt-2 text-sm text-sand-500">Freiwillige Erklärung · Stand: Oktober 2026</p>
        {BLOCKS.map((b) => (
          <section key={b.h} className="mt-8">
            <h2 className="font-heading font-bold text-lg text-sand-800">{b.h}</h2>
            <p className="mt-2 text-sand-700 leading-relaxed">{b.t}</p>
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
}
